import { DateTime } from "luxon";
import moment from "moment";
import React from "react";

import Typography from "@mui/material/Typography";
import { GridCellParams, GridColDef } from "@mui/x-data-grid-pro";

import { RelativeDate } from "../components/Date";
import { expiresSoon } from "./date";

export const accessedAt: GridColDef = {
  display: "flex",
  headerName: "Accessed",
  field: "accessedAt",
  flex: 1,
  type: "date",
  valueGetter: (_value, row) => {
    return row?.accessedAt?.seconds;
  },
  renderCell: function AccessedAtCell(params: GridCellParams) {
    return <RelativeDate timestamp={params?.row?.accessedAt} />;
  },
  sortComparator: (v1, v2) => {
    return (v1 as number) - (v2 as number);
  },
};

export const expiresAt: GridColDef = {
  display: "flex",
  headerName: "Expires",
  field: "expiresAt",
  flex: 1,
  type: "date",
  valueGetter: (_value, row) => {
    return row?.expiresAt?.seconds;
  },
  renderCell: function ExpiresCell(params: GridCellParams) {
    if (!params.row?.expiresAt?.seconds) {
      return <></>;
    }

    return (
      <Typography
        color={
          expiresSoon(params.row?.expiresAt?.seconds)
            ? "error.main"
            : "success.main"
        }
      >
        {moment.unix(params.row?.expiresAt?.seconds).fromNow()}
      </Typography>
    );
  },
  sortComparator: (v1, v2) => {
    return (v1 as number) - (v2 as number);
  },
};

export const issuedAt: GridColDef = {
  display: "flex",
  headerName: "Issued",
  field: "issuedAt",
  flex: 1,
  type: "date",
  valueGetter: (_value, row) => {
    return row?.issuedAt?.seconds;
  },
  renderCell: function IssuedAtCell(params: GridCellParams) {
    return <RelativeDate timestamp={params?.row?.issuedAt} />;
  },
  sortComparator: (v1, v2) => {
    return (v1 as number) - (v2 as number);
  },
};

export const updatedAt: GridColDef = {
  display: "flex",
  headerName: "Updated",
  field: "updatedAt",
  flex: 1,
  type: "date",
  valueGetter: (_value, row) => {
    return DateTime.fromISO(row?.updatedAt).toJSDate();
  },
  renderCell: function UpdatedAtCell(params: GridCellParams) {
    return <RelativeDate timestamp={params?.row?.updatedAt || ""} />;
  },
  sortComparator: (v1, v2) => {
    return (v1 as number) - (v2 as number);
  },
};

export const createdAt: GridColDef = {
  display: "flex",
  headerName: "Created",
  field: "createdAt",
  flex: 1,
  type: "date",
  valueGetter: (_value, row) => {
    return DateTime.fromISO(row?.createdAt).toJSDate();
  },
  renderCell: function CreatedAtCell(params: GridCellParams) {
    return <RelativeDate timestamp={params?.row?.createdAt || ""} />;
  },
  sortComparator: (v1, v2) => {
    return (v1 as number) - (v2 as number);
  },
};

export const dateTimeExpiresAt: GridColDef = {
  display: "flex",
  headerName: "Expires At",
  field: "expiresAt",
  flex: 1,
  type: "date",
  valueGetter: (_value, row) => {
    return DateTime.fromISO(row?.expiresAt).toJSDate();
  },
  renderCell: function CreatedAtCell(params: GridCellParams) {
    return <RelativeDate timestamp={params?.row?.expiresAt || ""} />;
  },
  sortComparator: (v1, v2) => {
    return (v1 as number) - (v2 as number);
  },
};
